<template>
  <div class="card">
    <div class="card-content columns">
      <div class="content column is-3 is-border-persist is-restricted-height">
        <b-field type="is-vert-clair">
          <b-input
            placeholder="Rechercher..."
            type="search"
            icon="search"
            v-model="recherche"
            rounded
          ></b-input>
        </b-field>
        <b-field
          v-for="(type, index) in listeTypes"
          v-bind:key="index"
          v-show="isSearch(type.nom)"
        >
          <b-checkbox v-model="typesSelect" :native-value="type">{{
            type.nom
          }}</b-checkbox>
        </b-field>
      </div>

      <div class="content column is-4" v-show="typesSelect.length">
        <p>Supprimer les produits suivants ?</p>
        <ul>
          <li v-for="(type, index) in typesSelect" v-bind:key="index">
            {{ type.nom }}
          </li>
        </ul>
        <b-button class="card-footer-item is-danger" @click="deleteTypes()"
          >Supprimer</b-button
        >
      </div>

      <div class="content column is-4">
        <b-field>
          <b-input placeholder="Type à ajouter" v-model="typeAjout" />
          <p class="control">
            <b-button type="is-success" @click="ajouterType"
              >Ajouter le type</b-button
            >
          </p>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import ListeTypes from "../classes/ListeTypes.js";
const { Type } = require("../classes/Type.js");

export default {
  name: "AdminGestionType",
  data() {
    return {
      recherche: "",
      typeAjout: "",
      typesSelect: [],
    };
  },
  created() {
    this.updateListeTypes();
  },
  computed: {
    listeTypes() {
      const resultat = this.$store.state.listeTypes;
      return resultat.liste;
    },
  },
  methods: {
    async ajouterType() {
      const newType = new Type(1, this.typeAjout.toLowerCase());
      await newType.ajoutType();
      this.updateListeTypes();
    },
    async deleteTypes() {
      for (let index = 0; index < this.typesSelect.length; index++) {
        await this.typesSelect[index].deleteType();
      }
      this.updateListeTypes();
    },
    isSearch(nom) {
      return !this.recherche
        ? true
        : nom.toLowerCase().includes(this.recherche.toLowerCase());
    },
    updateListeTypes: async function () {
      const maListe = new ListeTypes();
      await maListe.getTypes();
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="sass" scoped>
.is-restricted-height
  max-height: 40em
  overflow: auto
</style>
